// Phase 1A Phase 9C.2 — Risk gate icon definitions.
//
// 9 risk-gate glyphs. Shield = blocked / protection boundary, never
// "risk-free." Slash / X / wave geometry only. No team flags. No
// broker/wallet marks.

import type { IconDef } from "./icon-types.ts";

export const RISK_ICONS: Record<string, IconDef> = {
  "risk.rug_blocked": {
    key: "risk.rug_blocked",
    shapes: [
      { type: "path", d: "M12 4 L19 7 V12 C19 16 16 19 12 20 C8 19 5 16 5 12 V7 Z" },
      { type: "line", x1: 9, y1: 10, x2: 15, y2: 16 },
      { type: "line", x1: 15, y1: 10, x2: 9, y2: 16 },
    ],
  },
  "risk.data_release_blocked": {
    key: "risk.data_release_blocked",
    shapes: [
      { type: "circle", cx: 10, cy: 12, r: 6 },
      { type: "polyline", points: "10,8 10,12 12,13" },
      { type: "rect", x: 15, y: 11, width: 6, height: 2.5, rx: 0.8, filled: true },
    ],
  },
  "risk.sample_invalid": {
    key: "risk.sample_invalid",
    shapes: [
      { type: "polyline", points: "4,17 9,12 12,15 17,7" },
      { type: "line", x1: 16, y1: 14, x2: 20, y2: 18 },
      { type: "line", x1: 20, y1: 14, x2: 16, y2: 18 },
    ],
  },
  "risk.thin_data": {
    key: "risk.thin_data",
    shapes: [
      { type: "polyline", points: "4,17 9,13 14,15 20,9" },
      { type: "circle", cx: 9, cy: 13, r: 1.2, filled: true },
      { type: "circle", cx: 14, cy: 15, r: 1.2, filled: true },
    ],
  },
  "risk.high_spread": {
    key: "risk.high_spread",
    shapes: [
      { type: "line", x1: 5, y1: 12, x2: 11, y2: 12 },
      { type: "polyline", points: "8,9 5,12 8,15" },
      { type: "line", x1: 13, y1: 12, x2: 19, y2: 12 },
      { type: "polyline", points: "16,9 19,12 16,15" },
    ],
  },
  "risk.odds_drift": {
    key: "risk.odds_drift",
    shapes: [
      { type: "path", d: "M4 14 Q7 10 10 14 T16 14 T22 14" },
      { type: "polyline", points: "19,12 22,14 19,16" },
    ],
  },
  "risk.lineup_pending": {
    key: "risk.lineup_pending",
    shapes: [
      { type: "circle", cx: 6, cy: 12, r: 1.4, filled: true },
      { type: "circle", cx: 12, cy: 12, r: 1.4, filled: true },
      { type: "circle", cx: 18, cy: 12, r: 1.4, filled: true },
    ],
  },
  "risk.postponement_risk": {
    key: "risk.postponement_risk",
    shapes: [
      { type: "rect", x: 4, y: 6, width: 16, height: 13, rx: 1 },
      { type: "line", x1: 4, y1: 10, x2: 20, y2: 10 },
      { type: "line", x1: 8, y1: 4, x2: 8, y2: 8 },
      { type: "line", x1: 16, y1: 4, x2: 16, y2: 8 },
      { type: "polygon", points: "13,13 17,13 15,17", filled: true },
    ],
  },
  "risk.no_qualifying_market": {
    key: "risk.no_qualifying_market",
    shapes: [
      { type: "circle", cx: 12, cy: 12, r: 7 },
      { type: "line", x1: 7, y1: 17, x2: 17, y2: 7 },
    ],
  },
};
